import type { ISbStoryData } from '@storyblok/js'
import { Text } from '@percent/lemonade'
import type { ProductOfferPage } from '@percent/cause-dashboard/storyblok/types/storyblok-components'
import { RichTextRenderer } from '@percent/cause-dashboard/common/components/storyblok/richTextRenderer/RichTextRenderer'
import styles from './ProductOfferDetailCMSPage.module.scss'

export type ProductOfferDetailPageFromCmsContentProps = {
  story: ISbStoryData<ProductOfferPage>
}

export function ProductOfferDetailCMSPageContent({ story }: Readonly<ProductOfferDetailPageFromCmsContentProps>) {
  return (
    <div id="product-offer-detail-cms" className={styles.productOfferDetailWrapper}>
      <div className={styles.productOfferBannerWrapper}>
        <div className={styles.bannerContent}>
          {story.content.logo?.filename && (
            <img src={story.content.logo.filename} alt={story.content.title} className={styles.bannerIcon} />
          )}
          <Text className={styles.bannerTitle}>{story.content.title}</Text>
          {story.content.subtitle ? <Text className={styles.bannerDescription}>{story.content.subtitle}</Text> : null}
        </div>
      </div>

      <RichTextRenderer document={story.content.content} />
    </div>
  )
}
